import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNorthWest = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.9 19.3L7 8.4V14C7 14.2833 6.90433 14.5207 6.713 14.712C6.521 14.904 6.28333 15 6 15C5.71667 15 5.479 14.904 5.287 14.712C5.09567 14.5207 5 14.2833 5 14V6C5 5.71667 5.09567 5.479 5.287 5.287C5.479 5.09567 5.71667 5 6 5H14C14.2833 5 14.521 5.09567 14.713 5.287C14.9043 5.479 15 5.71667 15 6C15 6.28333 14.9043 6.521 14.713 6.713C14.521 6.90433 14.2833 7 14 7H8.4L19.3 17.9C19.4833 18.0833 19.575 18.3167 19.575 18.6C19.575 18.8833 19.4833 19.1167 19.3 19.3C19.1167 19.4833 18.8833 19.575 18.6 19.575C18.3167 19.575 18.0833 19.4833 17.9 19.3Z",
		fill: "currentColor"
	})
});
export default SvgNorthWest;
